import { plantDots, plantsSummary, useTrading } from "@helm/core";

/**
 * T / O / H / P: the Rithmic ticker, order, history and PnL plants of the session's login
 * (SPEC §17.2; launch blocker CB3), from the gateway's `SessionState.plants`. Green up, amber
 * reconnecting / degraded, red down, grey idle or unknown; the tooltip says why.
 */
export function PlantDots({
  connected,
  compact = false,
}: {
  /** The trading stream is up (otherwise the last states heard may be stale: shown unknown). */
  connected: boolean;
  compact?: boolean;
}): React.JSX.Element {
  const plants = useTrading((s) => s.session?.plants ?? null);
  const dots = plantDots(plants, connected);
  return (
    <span
      className={compact ? "plants plants-compact" : "plants"}
      role="group"
      aria-label={plantsSummary(dots)}
      title={compact ? dots.map((d) => d.title).join("\n") : undefined}
    >
      {dots.map((d) => (
        <span key={d.key} className={`dot ${d.tone}`} title={compact ? undefined : d.title}>
          {d.key}
          <span className="sr-only">
            {" "}
            {d.name} {d.label}
          </span>
        </span>
      ))}
    </span>
  );
}
